<template>
  <section>
    <div class="container clearfix py-5">
      <div class="row justify-content-center">
        <div class="col-12">
          <h1>Strateji</h1>
          <h2>Liderlik Modeli</h2>
          <div class="row mb-4">
            <div class="col-lg-4 mb-4 mb-lg-0 d-lg-flex">
              <div class="card">
                <div class="number">1</div>
                <div class="card-body px-5">
                  <h3 class="text-center mb-0">
                    Şirketin WEPs durumunun fotoğrafını çekmek
                  </h3>
                </div>
              </div>
            </div>
            <div class="col-lg-4 mb-4 mb-lg-0 d-lg-flex">
              <div class="card">
                <div class="number">2</div>
                <div class="card-body px-5">
                  <h3 class="text-center mb-0">
                    Şirketin gelişim alanlarını belirlemek
                    <br />
                    <em>Danışmanlık vermek</em>
                    <br />Takip etmek
                  </h3>
                </div>
              </div>
            </div>
            <div class="col-lg-4 mb-4 mb-lg-0 d-lg-flex">
              <div class="card">
                <div class="number">3</div>
                <div class="card-body px-5">
                  <h3 class="text-center mb-0">
                    Başarı hikayeleri ile veri/değer analizini iletişime taşımak
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <h2>Modelin Dinamiği</h2>
          <div class="row">
            <div class="col-md-6 d-md-flex">
              <div class="card">
                <div class="card-body">
                  <h3 class="text-danger">Büyük ölçekli şirketler için:</h3>
                  <p class="lead">
                    Kendini dönüştürmesi, ekosistemini etkileyip değiştirmesi ve
                    liderlik etmesi için uygulayabileceği model sunmak
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-6 d-md-flex">
              <div class="card">
                <div class="card-body">
                  <h3 class="text-danger">Orta ve küçük ölçekli şirketler:</h3>
                  <p class="lead">
                    Kendi şirketini dönüştürmesi ve ileriye taşıması için
                    rehberlik etmek
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  mounted() {
    this.$root.$emit("loaded");
  }
};
</script>

<style></style>
